import axios from "axios";

export const SECTION_URL = "/Section";
export const STUDENT_URL = "/Student";
export const TEACHER_URL = "/Teacher";
export const STUDENT_BOOK_REPORT_URL = "/StudentBookReport";

/** Mevcut Okula Ait Belli Bir Standart Kitap Raporunu Elde Eder */
export function getStandardReport(queryParams) {
  return axios.post(`${STUDENT_BOOK_REPORT_URL}/GetStandardReport`, queryParams);
}

/** Mevcut Okula Ait Belli Bir Standart Kitap Raporunu Sayfalama Olmadan Elde Eder */
export function getAllStandardReport(queryParams) {
  return axios.post(`${STUDENT_BOOK_REPORT_URL}/GetAllStandardReport`, queryParams);
}

/** Mevcut Okula Ait Belli Bir Kitap ve Sayfa Sayısı Raporunu Elde Eder */
export function getBookAndPageNumberReport(queryParams) {
  return axios.post(`${STUDENT_BOOK_REPORT_URL}/GetBookAndPageNumberReport`, queryParams);
}

/** Mevcut Okula Ait Belli Bir Kitap ve Sayfa Sayısı Raporunu Sayfalama Olmadan Elde Eder */
export function getAllBookAndPageNumberReport(queryParams) {
  return axios.post(`${STUDENT_BOOK_REPORT_URL}/GetAllBookAndPageNumberReport`, queryParams);
}

/** Mevcut Okula Ait Belli Bir Aylık Kitap Okuma Raporunu Elde Eder */
export function getMonthlyReport(queryParams) {
  return axios.post(`${STUDENT_BOOK_REPORT_URL}/GetMonthlyReport`, queryParams);
}

/** Mevcut Okula Ait Belli Bir Aylık Kitap Okuma Raporunu Sayfalama Olmadan Elde Eder */
export function getAllMonthlyReport(queryParams) {
  return axios.post(`${STUDENT_BOOK_REPORT_URL}/GetAllMonthlyReport`, queryParams);
}

/** Mevcut Okula Ait Şube Listesini Elde Eder */
export function getSections() {
  return axios.get(`${SECTION_URL}/GetSections`);
}

/** Mevcut Okula Ait Bir Dönemde Belli Bir Sınıftaki Öğrenci Listesini Elde Eder */
export function getStudents(term, sectionId) {
  return axios.get(`${STUDENT_URL}/GetStudentsInSection/${term}/${sectionId}`);
}

/** Mevcut Okula Ait Belli Bir Dönemde Sözleşmesi Olan Öğretmen Listesini Elde Eder */
export function getTeachers(term) {
  return axios.get(`${TEACHER_URL}/GetTeachers/${term}`);
}